import React from "react";
import './visual_communication.scss';

import data from "../home-page/data";
import data_2 from "./data";

import PrButtonComponent from "../../components/primitives/pr-button";
import SliderSectionComponent from "../../components/sections/slider-regular-entire";
import HeaderComponent2 from "../../components/sections/header/new_header/header";
import FooterComponent from "../../components/sections/footer";


export default class VisualCommunication extends React.Component {


    constructor(props) {
        super(props);
        this.state = {
            slider: data.slider,
            icoArr: data.icoArr,
            support: data_2.support,
            customers: data_2.customers,
            work: data_2.work,
            tabs1: data_2.tabs_1,
            tabs2: data_2.tabs_2,
            animated: false,
            tab2Index: 0,
            tab1Index: 0,
            illustrationTabActive: 0,
            illustrationTab: data_2.illustrationTabs
        }
        this.animationScroll = this.animationScrollController.bind(this);
        this.component = React.createRef();
        this.timer = null;
    }

    componentDidMount() {
        this.scrollWrapper = document.querySelector('.visual-communication-page');
        this.screensDOM = this.component.current.querySelectorAll('.y-sync');
        document.querySelector('.visual-communication-page').addEventListener('scroll',this.animationScroll);
        

        // setTimeout(()=>{
        //     this.transition(this.state.illustrationTabActive);
        // }, 2000)

        // this.component.current.querySelector('.illustration_tabs-' + this.state.illustrationTabActive).classList.add('animated');
        // // this.setState({illustrationTabActive: this.state.illustrationTabActive + 1});
        // this.transition(this.state.illustrationTabActive);

        this.timer = setInterval(()=>{
            // this.component.current.querySelector('.illustration_tabs-' + this.state.illustrationTabActive).classList.add('animated');
            this.setState({illustrationTabActive: this.state.illustrationTabActive + 1});
            // this.transition(this.state.illustrationTabActive);
        }, 5000)
    }
    componentWillUpdate(){
        console.log(this.state.illustrationTab.length, this.state.illustrationTabActive)
        if(this.state.illustrationTabActive === this.state.illustrationTab.length - 1){
            this.setState({illustrationTabActive: 0})
            clearInterval(this.timer);
            this.timer = setInterval(()=>{
                this.setState({illustrationTabActive: this.state.illustrationTabActive + 1});
            }, 5000)
        }
    }

    // transition(index){
    //     this.component.current.querySelector('.illustration_tabs-' + index).classList.add('animated');
    //     let block = this.component.current.querySelector('.illustration_tabs-' + index);
    //     let hookEnd;
    //     const hook = new Promise ((resolve, reject) => {
    //         hookEnd = resolve;
    //     });
    //     block.querySelector('img:last-child').ontransitionend = function(event) {
    //         console.log(index, block, 'index')
    //         block.classList.remove('animated');
    //         hookEnd();
    //     }
    //     hook.then(e => {
    //         if (this.state.illustrationTabActive === this.state.illustrationTab.length - 1) {
    //             clearInterval(this.timer);
    //             this.setState({illustrationTabActive: 0})
    //             this.timer = setInterval(()=>{
    //                 this.setState({illustrationTabActive: this.state.illustrationTabActive + 1});
    //             }, 5000)
    //         } else {
    //             this.timer = setInterval(()=>{
    //                 this.setState({illustrationTabActive: this.state.illustrationTabActive + 1});
    //             }, 5000)
    //         }
    //     })
    // }

    animationScrollController() {
        for (let index = 0; index < this.screensDOM.length; index++) {
          if (
            !this.screensDOM[index].classList.contains('enter')
            && this.screensDOM[index].getBoundingClientRect().top - window.innerHeight < 40
            && this.screensDOM[index].getBoundingClientRect().bottom > 40
          ) {
            this.screensDOM[index].classList.add('enter');
          } else if (
            this.screensDOM[index].classList.contains('enter')
            &&
            !this.screensDOM[index].classList.contains('once')
            &&
            (
              (this.screensDOM[index].getBoundingClientRect().top - window.innerHeight > 40
              && this.screensDOM[index].getBoundingClientRect().bottom > 40)
            ||
              (this.screensDOM[index].getBoundingClientRect().top - window.innerHeight < 40
              && this.screensDOM[index].getBoundingClientRect().bottom < 40))
          ) {
            this.screensDOM[index].classList.remove('enter');
          }
        }
    }
    componentDidUpdate(){
        console.log(this.tab2Index, 'this.tab2Index ' )
    }

    componentWillUnmount(){
        this.scrollWrapper.removeEventListener('scroll', this.scrollListener);
    }

    render(){
        return (
            <div className={`page-wrapper visual-communication-page`} ref={this.component}>
                <HeaderComponent2></HeaderComponent2>

                <main className={`content-wrapper ${this.state.animated ? 'scrolled' : ''}`}>

                    <section className="section-1">
                        <div className="top">
                            <p className="mobile-block text-style--t3">The Visual Communication Platform</p>
                            <div className="title extra-title--h1">
                                <p>The visual communication <br/> platform for teams</p>
                            </div>
                            <div className="wrap-top">
                                <p className="subtitle text-style--t2"> Powtoon makes it easy your team transform traditional materials into engaging videos and branded visual content, at scale.</p>
                                <div className="wrap">
                                    <PrButtonComponent type="primary medium" content="Talk to Sales" link="https://www.powtoon.com/account/signup/"></PrButtonComponent>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="section-2">
                        <div className="illustration">
                            <img className="img-header" src="https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617197662/hp2021/banners%202/macos_bar_3x.png" alt="#" / >
                            <img className={`img-footer ${this.state.illustrationTabActive === 4 ? 'hidden' : ''}`} src="https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617197662/hp2021/banners%202/timeline_3x.png" alt="#" / >
                                {this.state.illustrationTab.map((value, index) => 
                                    <div className={`illustration_tabs illustration_tabs-${index} ${this.state.illustrationTabActive === index ? 'active' : ''}`} key={index} >
                                        {Object.entries(value.listImg).map((val, i) =>
                                            <img key={i} src={val[1]} className={`${val[0]}`} alt="#"/>
                                        )}
                                    </div>
                                )}
                        </div>
                        <img className="bg-image" src="https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617195867/hp2021/general/background_3x.png" alt="#" / >
                    </section>

                    <section className="section-3">
                        <div className="wrap">
                            {this.state.customers.map((value, index) => 
                                <img src={value} alt="#"/>
                            )}
                            <PrButtonComponent type="secondary smallfont" content="See all customer stories >" link="https://www.powtoon.com/account/signup/"></PrButtonComponent>
                        </div>
                    </section>
                

                    <section className="section-4 section-general">
                        <p className="extra-title--h2 title y-sync">Why 96% of Fortune <br/>500 companies choose Powtoon</p>
                        <div className="wrap">
                            <ul className="tabs_list">
                                {this.state.tabs1.map((value, index) => 
                                    <li key={index} className={`${this.state.tab1Index === index ? 'active' : ''}`} onClick={(event) =>  this.setState({tab1Index: index})}>
                                        <p className="text-style--t2">{value.title}</p>
                                        <p className="text-style--t1">{value.desc}</p>
                                    </li>
                                )}
                            </ul>
                            <div className="tabs_section">
                                {this.state.tabs1.map((value, index) => 
                                    <div className={`tab-sections_item tab-sections_item-${index} ${this.state.tab1Index === index ? 'active' : ''}`} key={index}>
                                        {Object.entries(value.listImg).map((val, i) =>
                                          <img key={i} src={val[1]} className={`${val[0]}`} alt="#"/>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                        <PrButtonComponent type="primary medium" link="https://www.powtoon.com/account/signup/" content="Connect with a solution expert"></PrButtonComponent>
                    </section>


                    <section className="section-5 section-general">
                        <p className="extra-title--h2 title center-underlined y-sync">One platform. <br/> Unique solutions for every team.</p>
                        <div className="wrap">
                            <ul className="tab-list_2">
                                {this.state.tabs2.map((value, index) => 
                                    <li key={index} className={`text-style--t1 ${this.state.tab2Index === index ? 'active' : ''}`} onClick={(event) =>  this.setState({tab2Index: index})}>{value.title}</li>
                                )}
                            </ul>
                            <div className="tab-s">
                                <div className="illustration-block">
                                    <div className="imgs-wrap">
                                        <img src="https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617181204/hp2021/tabs%202/browser_header_3x.png" className="img-header" alt="#" />
                                        <img src="https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617181204/hp2021/tabs%202/browser_center_bar_3x.png" className="img-nav" alt="#" />
                                        <img src="https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617181214/hp2021/tabs%202/browser_side_bar_3x.png" className="img-sidebar" alt="#" />
                                        <img src="https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617181218/hp2021/tabs%202/browser_timeline_3x.png" className="img-footer" alt="#" />
                                        <img src="https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617184019/hp2021/tabs%202/browser_icons_3x.png" className="img-toolbar" alt="#" />
                                    </div>
                                </div>
                                {this.state.tabs2.map((value, index) => 
                                    <div className={`tab-s_item tab-s_item-${index} ${this.state.tab2Index === index ? 'active' : ''}`} key={index}>
                                        <div className="content">
                                            <p className="title extra-title--h2">{value.title}</p>
                                            <p className="desc extra-title--h6">{value.desc}</p>
                                            <PrButtonComponent type="secondary smallfont" content="Learn more" link="https://www.powtoon.com/account/signup/"></PrButtonComponent>
                                        </div>
                                        {Object.entries(value.listImg).map((val, i) =>
                                          <img key={i} src={val[1]} className={`${val[0]}`} alt="#"/>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </section>

                    <section className="section-6 section-general y-sync">
                        <p className="extra-title--h2 title center-underlined y-sync">This is how it works</p>
                        <div className="wrap">
                            {this.state.work.map((value, index) => 
                                <div className="item" key={index}>
                                    <div className="img-wrap">
                                        <div className={`imgs imgs-${index}`}>
                                            {Object.entries(value.listImg).map((val, i) =>
                                                <img key={i} className={val[0]} src={val[1]} alt="#"/>
                                            )}
                                        </div>
                                    </div>
                                   <p className="title text-style--t2">{value.title}</p>
                                   <ul>
                                        {value.list.map((val, i) => 
                                            <li key={i} className="text-style--t1">{val}</li>
                                        )}
                                   </ul>
                               </div>
                            )}
                        </div>
                    </section>

                    <section className="section-7">
                        <SliderSectionComponent slider={this.state.slider}></SliderSectionComponent>
                    </section>

                    <section className="section-8 y-sync">
                        <div className="container">
                            <div className="column column-left">
                                <img src="https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617107052/hp2021/forms_2/highly_secure_round.svg" className="dec dec-0" alt="#"/>
                                <img src="https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617107052/hp2021/forms_2/highly_secure_square.svg" className="dec dec-1" alt="#"/>
                                <img src="https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617108705/hp2021/general/highly_secure_image_3x.png" className="bg" alt="#"/>
                            </div> 
                            <div className="column column-right">
                                <p className="title extra-title--h2 transition y-sync">Highly secure & <br/> fully compliant</p>
                                <p className="subtitle text-style--t2 transition y-sync">Powtoon follows strict international standards and regulations like GDPR and ISO in order to keep your organization’s information safe.</p>
                            </div> 
                        </div>
                    </section>

                    <section className="section-9 section-general y-sync">
                        <p className="extra-title--h2 title center-underlined y-sync">Fast adoption. Tailored support.</p>
                        <div className="wrap">
                            {this.state.support.map((value, index) => 
                                <div className="item" key={index}>
                                   <img src={value.photo} alt="#"/>
                                   <p className="title text-style--t3">{value.title}</p>
                                   <p className="desc text-style--t1">{value.desc}</p>
                               </div>
                            )}
                        </div>
                    </section>

                    <section className="section-10 y-sync">
                        <div className="wrap">
                            <p className="title extra-title--h2 transition y-sync">Join 96% of Fortune 500</p>
                            <p className="subtitle extra-title--h2 transition y-sync">companies using Powtoon.</p>
                            <div className="btn transition y-sync">
                                <PrButtonComponent type="primary medium" link="https://www.powtoon.com/account/signup/" content="TALK TO SALES"></PrButtonComponent>
                            </div>
                        </div>
                        <img src="https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617108634/hp2021/forms_2/cta_drop.svg" className="form form-0" alt="#"/>
                        <img src="https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1617108634/hp2021/forms_2/cta_half_circle.svg" className="form form-1" alt="#"/>
                    </section>

                </main>

                <FooterComponent></FooterComponent>

            </div>
        );
    }
}
